import styled from 'styled-components'

import {Item} from '../TopNavigation/TopNavigation.styles'

const mobNavFull = 576

export const MobileNavigationWrapper = styled.div`
  padding: 25px 15px;
  position: fixed;
  width: 375px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: ${({theme}) => theme.sizes.navigationHeight};
  right: 0;
  bottom: 0;
  transition: all 300ms ease-in-out;
  background: ${({theme}) => theme.colors.bgPaper};
  border-left: 1px solid ${({theme}) => theme.colors.border};
  z-index: 1;

  @media (max-width: ${mobNavFull}px) {
    width: 100%;
  }

  &.slide-enter {
    transform: translateX(100%);
  }

  &.slide-enter-active,
  &.slide-enter-done {
    transform: translateX(0);
  }

  &.slide-exit {
    transform: translateX(0);
  }

  &.slide-exit-active {
    transform: translateX(100%);
  }
`

export const MobileNavigationLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const MobNavLink = styled(Item)`
  transition-duration: 200ms;
  padding: 0;
  outline: none;
  appearance: none;
  background: transparent;
  border: 0;
  margin-right: 0;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: ${({theme}) => theme.fontSizes.medium};

  &:after {
    height: auto;
    left: auto;
    right: -15px;
    top: 0;
    width: 7px;
  }
`
export const MobNaVDarkBg = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${({theme}) => theme.colors.modalBackground};
  transition: all 0.2s linear;
  z-index: 0;

  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active,
  &.fade-enter-done {
    opacity: 1;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
  }
`

export const LogoutButton = styled(MobNavLink)`
  margin-bottom: 0;
  height: auto;
`
